import { apiClient } from './apiClient'
import type { RailCar } from '../types/interchange'

export function getAvailableLocomotives(facilityId: string): Promise<RailCar[]> {
  return apiClient.get<RailCar[]>(`/api/v1/locomotives/available?facilityId=${facilityId}`)
}
